import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  ButtonModule,
  FormControlModule,
  ZipBusyModule,
  ReadMoreModule,
} from '@zipari/design-system';

import { CoverageEffectiveDateComponent } from './coverage-effective-date.component';
import { NavigationModule } from '../navigation/navigation.module';

@NgModule({
  declarations: [CoverageEffectiveDateComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    FormControlModule,
    NavigationModule,
    ZipBusyModule,
    ReadMoreModule,
  ],
  exports: [CoverageEffectiveDateComponent],
})
export class CoverageEffectiveDateModule {}
